import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
const CourseSliderAdListHeader = () => {
  const history = useHistory();
  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => {
            history.push({
              pathname: "/main/course/slider-ads/edit",
            });
          }}
          type="primary"
        >
          {i18n.t("course.sliderAd.add")}
        </Button>
      </div>
    </div>
  );
};
export default CourseSliderAdListHeader;
